import React, { useEffect, useMemo, useState } from "react";
import Iframe from "react-iframe";
import { useDispatch, useSelector } from "react-redux";

import { useAppInsights } from "../components/AppInsightsProvider";
import ControlComponent from "../components/ControlComponent";
import HelpModal from "../components/HelpModalComponent";
import IFrameControl from "../components/IFrameControl";
import LoadingComponent from "../components/LoadingComponent";
import useURL from "../hooks/useURL";
import { resetLayout } from "../store/ducks/duckLayout";
import { useStylesLayout } from "../styles/Layout";

const LayoutSimple = () => {
  const classes = useStylesLayout();
  const {
    filters,
    source: sourceUrl,
    requiredNormalAuth,
    sso,
    requireFormatNumber,
  } = useSelector((state) => state.layout?.layoutSelected);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const sessionLoading = useSelector((state) => state.session.loading);

  const { history, historyLoaded } = useSelector((state) => state.layout);
  const appInsights = useAppInsights();

  useEffect(() => {
    setLoading(true);
    // eslint-disable-next-line
  }, [history, appInsights, setLoading]);

  useEffect(() => {
    return () => dispatch(resetLayout());
  }, [dispatch]);
  // eslint-disable-next-line
  const { cleanParams, replaceString } = useURL(requireFormatNumber);
  // eslint-disable-next-line
  const urlWithParams = useMemo(
    () => cleanParams(sourceUrl, requiredNormalAuth, sso),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, sessionLoading, historyLoaded],
  );

  const handleLoad = (e) => {
    e.preventDefault();
    setLoading(false);
  };

  const handleError = (e) => {
    if (count < 3) {
      setInterval(() => {
        setCount(count + 1);
      }, 3000);
    } else {
      e.preventDefault();
      appInsights.setAuthenticatedUserContext(localStorage.getItem("Email"));
      appInsights.trackEvent({
        name: "Error al cargar el Iframe",
        properties: { filters: history, sourceUrl },
      });
    }
  };

  return (
    <div key={"Layout-Simple-Container"} style={{ height: "100%" }}>
      <IFrameControl
        filters={filters}
        replaceString={replaceString}
        simple={true}
        sourceUrl={sourceUrl}
      />
      <ControlComponent simple />
      <HelpModal />

      {loading || sessionLoading ? (
        <LoadingComponent withoutNavBar loading={loading || sessionLoading} />
      ) : null}
      <Iframe
        dangerouslySetInnerHTML
        className={classes.pageContentSimple}
        display={loading || sessionLoading ? "none" : "block"}
        height="100%"
        id="myId"
        position="fixed"
        style={{ zIndex: "-1px" }}
        url={urlWithParams}
        width="100%"
        onError={handleError}
        onLoad={handleLoad}
      />
    </div>
  );
};

export default React.memo(LayoutSimple);
